import { useSelector } from 'hooks/utils';

export const useLanguage = () => useSelector(state => state.ui.i18n.language);
